"use client";

import { useTranslations } from "next-intl";
import React, { ComponentPropsWithRef, forwardRef, useContext, useRef } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

import CheckBox from "@/components/ui/Form/CheckBox/CheckBox";
import { controlledCheckbox } from "@/components/ui/Form/Filters/FilterUtils";

export interface CheckboxBaseProps extends ComponentPropsWithRef<"input"> {
  name: string;
  filter: string;
  displayInSearchBar?: boolean;
  values?: (string | number)[] | undefined;
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
  parentForm?: string;
  availableValues?: (string | number)[] | undefined;
}

const CheckboxBase = forwardRef<HTMLInputElement, CheckboxBaseProps>(
  ({ name, filter, displayInSearchBar = false, field, fieldState, values, availableValues, ...rest }, ref) => {
    const t = useTranslations();
    const checkboxes = useRef<(HTMLInputElement | null)[]>([]);
    return (
      <div className={`pt-xs px-m pb-m grid grid-cols-2`}>
        {values?.map((value) => {
          const filedUID = `filter-${name}-${value}`;
          return (
            <CheckBox
              checked={field?.value?.includes(value as string) ?? false}
              key={filedUID}
              label={t(`filter.label.${name}.${(value as string).replaceAll(" & ", "-").replaceAll("&", "-").replaceAll(" ", "-")}`)}
              name={name}
              value={value as string}
              onChange={(event) => controlledCheckbox(field, event)}
              disabled={availableValues && availableValues.length > 0 ? !availableValues?.includes(value) : false}
            />
          );
        })}
      </div>
    );
  },
);
CheckboxBase.displayName = "CheckboxBase";
export default CheckboxBase;
